export default __webpack_public_path__ + "resources/icons/n131-7f62.webp";